import React from 'react';
import styled from 'styled-components';

const TypeChip = styled.div<{ $type: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  padding: 0 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  user-select: none;
  transition: all 0.2s ease;

  ${({ $type }) =>
    $type === 'business'
      ? `
    background-color: #E3F2FD; 
    color: #1565C0;
    border: 1px solid #1565C0;
    
    &:hover {
      background-color: #BBDEFB;
    }
  `
      : `
    background-color: #F3E5F5;
    color: #6A1B9A;
    border: 1px solid #6A1B9A;
    
    &:hover {
      background-color: #E1BEE7;
    }
  `}
`;

type PersonalBusinessClassificationChipProps = {
  type: string | null;
  onClick?: () => void;
};

export const PersonalBusinessClassificationChip = React.memo(
  ({ type, onClick }: PersonalBusinessClassificationChipProps): React.ReactElement => {
    // Treat null/undefined as 'PERSONAL'
    const normalizedType = type || 'PERSONAL';

    return (
      <TypeChip $type={normalizedType.toLowerCase()} onClick={onClick}>
        {normalizedType === 'BUSINESS' ? 'Business' : 'Personal'}
      </TypeChip>
    );
  },
);

PersonalBusinessClassificationChip.displayName = 'PersonalBusinessClassificationChip';
